import { connect } from 'react-redux'
import { getRelationkeyLabel } from 'Services/WeaverUtils'
import ColorService from 'Services/ColorService'
import { withFilterData } from 'Components'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from '@reduxjs/toolkit'
import { setRelationFilters, updateRelationFilter, updateRelationFilters } from 'Actions/graphFilter'
import { store } from '~/Store'
import { RELATION } from 'Types'
import { DisabledRelations } from 'Model'
import FilterHeader from './FilterHeader'
import FilterBody from './FilterBody'
import GraphFilterItem from './GraphFilterItem'
import tabStyles from './tabStyles'

getRelations = ({ edges, selectedItems }) ->
  _.reduce(edges, (acc, relation) ->
    { id, key } = relation
    return {} unless key
    {
      acc...
      [key]: {
        key
        enabled: if item = selectedItems.find((item) -> item.key is key) then item.enabled else true
        label: getRelationkeyLabel(key, id)
      }
    }
  , {})

relationFilterSelector = createSelector((state) ->
  state.graphFilter.relationFilters
, _.values)

GraphFilterRelations = ({ items }) ->
  dispatch = useDispatch()
  relationFilters = useSelector(relationFilterSelector)

  [filterValue, setFilterValue] = useState("")
  [configNode, setConfigNode] = useState(undefined)

  useEffect(->
    dispatch(setRelationFilters(
      _.keyBy(
        _.sortBy(items, ['enabled', (item) -> item.label.toLowerCase()])
      , 'key')
    ))
    ( ->
      setConfigNode(await DisabledRelations.load())
    )()
    undefined
  , [items])

  CellRenderItem = ({ item, props... }) ->
    { explore: { disabledRelations}} = store.getState()
    enableByDefault = !disabledRelations.includes(item.key)
    itemProps = {
      itemType: RELATION
      enabled: item.enabled
      value: item.key
      label: item.label
      enableByDefault
      ...props
    }

    <GraphFilterItem { itemProps... } />

  <div style={tabStyles}>
    <FilterHeader updateFilters={updateRelationFilters}
                  items={relationFilters}
                  idField='key'
                  onFilter={setFilterValue} />
    <FilterBody configNode={configNode}
                items={relationFilters}
                idField='key'
                filterValue={filterValue}
                updateFilter={updateRelationFilter}
                CellRenderItem={CellRenderItem} />
  </div>

export default withFilterData(GraphFilterRelations, getRelations, relationFilterSelector)

